import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  height: 100%;
`;
export const ConversationList = styled.div`
  width: 255px;
  padding: var(--spacing-07) var(--spacing-06);
  margin-right: var(--spacing-07);
  border-right: 1px solid var(--coolest-gray-30);
`;
export const ConversationPane = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  width: 35%;
  height: 100%;
  justify-content: flex-end;
  position: relative;
  padding-bottom: 130px;

  &::before {
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 90%
    );
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const MessageItem = styled.div`
  display: flex;
  margin-bottom: var(--spacing-05);
  .ant-skeleton {
    margin-right: var(--spacing-03);
  }

  .ant-skeleton-paragraph {
    margin: 0;
  }

  .ant-skeleton-title {
    margin: 0 0 var(--spacing-03);
  }

  .ant-skeleton-content .ant-skeleton-paragraph > li {
    height: var(--spacing-03);

    &::first-child {
      height: var(--spacing-04);
    }
  }

  .ant-skeleton-content .ant-skeleton-paragraph > li + li {
    margin-top: var(--spacing-03);
  }
`;

export const ListItem = styled.div`
  display: flex;
  margin-bottom: var(--spacing-03);
`;

export const ListTitle = styled.div`
  margin-top: var(--spacing-07);
  margin-bottom: var(--spacing-02);
  .ant-skeleton-content .ant-skeleton-paragraph > li {
    height: var(--spacing-03);
  }
`;
